import { motion, useInView } from "framer-motion";
import { useRef } from "react";

/**
 * Standard section reveal — slight y translate + fade.
 * Uses framer-motion for micro-interactions and staggered entrance.
 */
export default function Reveal({
  children,
  y = 24,
  delay = 0,
  duration = 0.9,
  once = true,
  className = "",
  as = "div",
}) {
  const ref = useRef(null);
  const inView = useInView(ref, { once, amount: 0.2 });
  const MotionTag = motion[as] || motion.div;

  return (
    <MotionTag
      ref={ref}
      className={className}
      initial={{ opacity: 0, y }}
      animate={inView ? { opacity: 1, y: 0 } : { opacity: 0, y }}
      transition={{ duration, delay, ease: [0.19, 1, 0.22, 1] }}
    >
      {children}
    </MotionTag>
  );
}
